import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, StarHalf, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';

export const RoomCard = ({ room }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language];

  const handleLearnMore = () => {
    navigate(`/room/${room.id}`);
  };

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(room.difficulty);
    const hasHalfStar = room.difficulty % 1 >= 0.5;
    
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(
          <Star
            key={i}
            className="w-5 h-5 fill-gold text-gold"
          />
        );
      } else if (i === fullStars && hasHalfStar) {
        stars.push(
          <div key={i} className="relative w-5 h-5">
            <Star className="w-5 h-5 text-gold/30 absolute" />
            <div className="overflow-hidden w-[50%] absolute">
              <Star className="w-5 h-5 fill-gold text-gold" />
            </div>
          </div>
        );
      } else {
        stars.push(
          <Star
            key={i}
            className="w-5 h-5 text-gold/30"
          />
        );
      }
    }
    return stars;
  };

  return (
    <div className="group relative bg-navy-darker border border-gold/20 rounded-xl overflow-hidden hover:border-gold/60 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-gold/20">
      {/* Image */}
      <div className="relative h-64 overflow-hidden cursor-pointer" onClick={handleLearnMore}>
        <img
          src={room.image}
          alt={language === 'en' ? room.title : room.titleFr}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-darker via-transparent to-transparent opacity-60"></div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-gold mb-2 countdown-font">
          {language === 'en' ? room.title : room.titleFr}
        </h3>
        <p className="text-sm uppercase text-gold/70 mb-4 tracking-wide font-semibold">
          {language === 'en' ? room.subtitle : room.subtitleFr}
        </p>
        
        {/* Price */}
        <div className="flex items-center gap-2 mb-4 bg-gold/10 rounded-lg px-3 py-2 border border-gold/30">
          <span className="text-2xl font-bold text-gold countdown-font">${room.price}</span>
          <span className="text-sm text-cream/80">{t.rooms.price}</span>
        </div>
        
        <p className="text-sm text-cream/80 mb-6 leading-relaxed">
          {language === 'en' ? room.description : room.descriptionFr}
        </p>

        {/* Difficulty */}
        <div className="flex items-center gap-2 mb-4">
          <span className="text-xs uppercase text-cream/70 tracking-wide">{t.rooms.difficulty}:</span>
          <div className="flex gap-1">{renderStars()}</div>
        </div>

        {/* Record Time */}
        <div className="flex items-center gap-2 mb-6 text-cream/70">
          <Clock className="w-4 h-4" />
          <span className="text-xs uppercase tracking-wide">
            {t.rooms.record}: {language === 'en' ? room.recordTime : room.recordTimeFr}
          </span>
        </div>

        {/* Button */}
        <button onClick={handleLearnMore} className="btn-secondary w-full">
          {t.rooms.learnMore}
        </button>
      </div>
    </div>
  );
};